import { BuoyMappedForDrawing } from '../buoy';
import { GridLineDrawingPropertyDto } from 'models/mooring';
import { ServiceCorridorData } from '../renderOptions';

export function calculateServiceCorridorData(
  clickedGridLineId: number,
  grid: BuoyMappedForDrawing[][],
  gridLines: GridLineDrawingPropertyDto[]
): ServiceCorridorData | null {
  if (!grid.length || !grid[0].length) {
    return null;
  }

  const clickedLine = gridLines.find((l) => l.Id === clickedGridLineId);
  if (!clickedLine) {
    return null;
  }

  const rows = grid.length;
  const cols = grid[0].length;

  // Find the clicked line's buoys in the grid
  let clickedLineInfo: { row: number; col: number; direction: 'horizontal' | 'vertical' } | null = null;

  // Check horizontal lines
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols - 1; col++) {
      const buoy1 = grid[row][col];
      const buoy2 = grid[row][col + 1];

      const matches =
        (clickedLine.FromBuoyId === buoy1.Id && clickedLine.ToBuoyId === buoy2.Id) ||
        (clickedLine.FromBuoyId === buoy2.Id && clickedLine.ToBuoyId === buoy1.Id);

      if (matches) {
        clickedLineInfo = { row, col, direction: 'horizontal' };
        break;
      }
    }
    if (clickedLineInfo) break;
  }

  // Check vertical lines if not found
  if (!clickedLineInfo) {
    for (let row = 0; row < rows - 1; row++) {
      for (let col = 0; col < cols; col++) {
        const buoy1 = grid[row][col];
        const buoy2 = grid[row + 1][col];

        const matches =
          (clickedLine.FromBuoyId === buoy1.Id && clickedLine.ToBuoyId === buoy2.Id) ||
          (clickedLine.FromBuoyId === buoy2.Id && clickedLine.ToBuoyId === buoy1.Id);

        if (matches) {
          clickedLineInfo = { row, col, direction: 'vertical' };
          break;
        }
      }
      if (clickedLineInfo) break;
    }
  }

  if (!clickedLineInfo) {
    return null;
  }

  const buoyPairs: Array<{ fromBuoyId: number; toBuoyId: number }> = [];

  if (clickedLineInfo.direction === 'horizontal') {
    // Horizontal line clicked - add a new row after this row
    const { row } = clickedLineInfo;

    // Collect all buoy pairs in this row
    for (let col = 0; col < cols - 1; col++) {
      const fromBuoy = grid[row][col];
      const toBuoy = grid[row][col + 1];
      buoyPairs.push({ fromBuoyId: fromBuoy.Id, toBuoyId: toBuoy.Id });
    }

    return {
      direction: 'row',
      afterIndex: row,
      buoyPairs,
    };
  } else {
    // Vertical line clicked - add a new column after this column
    const { col } = clickedLineInfo;

    // Collect all buoy pairs in this column
    for (let row = 0; row < rows - 1; row++) {
      const fromBuoy = grid[row][col];
      const toBuoy = grid[row + 1][col];
      buoyPairs.push({ fromBuoyId: fromBuoy.Id, toBuoyId: toBuoy.Id });
    }

    return {
      direction: 'column',
      afterIndex: col,
      buoyPairs,
    };
  }
}
